const TYPES = {
  UPDATE_PORTFOLIOS: "UPDATE_PORTFOLIOS",
  UPDATE_SELECTED_PORTFOLIO: "UPDATE_SELECTED_PORTFOLIO",
  TOGGLE_AUTO_SLIDER: "TOGGLE_AUTO_SLIDER",
  RESET_INTERACTION_TIMER: "RESET_INTERACTION_TIMER"
};

export default TYPES;
